import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListIdentityCell } from './charge-point-list-identity.cell';
import { ChargePointListIdentityHeader } from './charge-point-list-identity.header';

export const ChargePointListIdentityColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['identity']
> = {
  enableSorting: false,
  header: ChargePointListIdentityHeader,
  cell: ChargePointListIdentityCell,
  meta: { maxWidth: '160px', width: '150px' },
};
